import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Create a placeholder client if environment variables are missing.
// This allows the app to run without Supabase in demo mode.
export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => Boolean(supabase)

export type {
  Agent,
  AgentRecord,
  AgentIntegration,
  AgentIntegrationRecord,
  AgentSubmission,
  AgentSubmissionRecord,
  AgentEdit,
  AgentEditRecord,
  AgentEditForm,
  AgentEditPayload,
  EnablerSubmission,
  EnablerSubmissionRecord,
  Enabler,
  EnablerRecord,
  EnablerEdit,
  EnablerEditRecord,
  EnablerEditPayload,
  Provider,
  ProviderRecord,
  ProviderProfile,
  ProviderProfileRecord,
  ImpactMetric,
  ImpactMetricRecord
} from '@/types/supabase'

// Self Assessment types - import from dedicated types file
export type {
  SelfAssessment,
  SelfAssessmentResult,
  AssessmentAnswers,
  AssessmentAnalysis,
  PillarAnalysis,
  OverallSummary,
  ScoredAnswer,
  SubmitAssessmentResponse,
  GetAssessmentResultResponse,
  AssessmentError,
  AssessmentStatus,
  MaturityLevel
} from '@/types/selfAssessment'
